import { useCallback, useEffect, useState } from "react";

export const useActiveElement = () => {
  const [activeElement, setActiveElement] = useState<HTMLElement | null>(
    document.activeElement as HTMLElement,
  );

  // setTimeout is used because of weird behavior if state changes during event handling

  const handleFocus = useCallback(() => {
    const newActiveElement = document.activeElement;
    setTimeout(() => {
      setActiveElement(newActiveElement as HTMLElement);
    }, 0);
  }, []);

  const handleBlur = useCallback(() => {
    setTimeout(() => {
      setActiveElement(null);
    }, 0);
  }, []);

  useEffect(() => {
    const opts: AddEventListenerOptions = { capture: true, passive: true };
    window.addEventListener("focus", handleFocus, opts);
    window.addEventListener("blur", handleBlur, opts);
    return () => {
      window.removeEventListener("focus", handleFocus, opts);
      window.removeEventListener("blur", handleBlur, opts);
    };
  }, [handleBlur, handleFocus]);
  return activeElement;
};
